import layeredSoilAttribute from './layeredSoilAttribute';

const kFactor = (allLayers: boolean) =>
  layeredSoilAttribute({
    aggregationMethod: 'Dominant Condition',
    allLayers,
    key: 'K Factor, Whole Soil',
    ruleId: '51',
  });

export const K_FACTOR_ALL_LAYERS = kFactor(true);
export const K_FACTOR_SURFACE_LAYER = kFactor(false);
